<template lang="pug">
  section.md-px-10.overflow-hidden(v-if="doc && id")
    header.font-sabon.text-center.px-20.mb-34
      h6.text-14(v-if="!isLibrary") Further Reading
      h2.text-24 {{doc.title.rendered}}
    section.relative.flex.flex-wrap.items-center.justify-center.py-50.px-5.md-px-10
      //- articles
      article.w-1x2.sm-w-1x3.md-w-1x5.px-5.md-px-10.text-center.my-50.relative.z-10(v-for="item in doc.acf.articles")
        article-link.hover-text-app-text.hover-scale-figure.trans-quicker(:to="rt(item.article[0].post_name)")
          figure(v-if="item.image")
            resp-img(:lazy="true", :src="item.image.url", :alt="item.image.alt")
          h4.font-sabon.text-14.pt-15(:to="rt(item.article[0].post_name)" v-html="title(item.article[0])")
      //- circle
      svg-ellipse.absolute.z-0.h-full.w-130pct.md-w-full
</template>

<script>
import ArticleLink from '@/components/ArticleLink'
import RespImg from '@/components/RespImg'
import svgEllipse from '@/components/Icons/SVG-Ellipse'
export default {
  name: 'ArticleCollection',
  props: ['id', 'isLibrary'],
  data () {
    return {
      doc: null
    }
  },
  methods: {
    rt (slug) {
      return { name: 'article', params: { slug: slug } }
    },
    title (article) {
      return (article.acf && article.acf.title_on_index) || article.post_title
    },
    fetchACFfields () {

    }
  },
  created () {
    if (this.id) this.$store.dispatch('getArticleCollection', this.id).then(doc => { this.doc = doc })
  },
  components: { RespImg, svgEllipse, ArticleLink }
}
</script>

<style>
</style>
